import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=0cf54333&scoped=true&lang=pug&"
import script from "./Progress.vue?vue&type=script&lang=ts&"
export * from "./Progress.vue?vue&type=script&lang=ts&"
import style0 from "./Progress.vue?vue&type=style&index=0&id=0cf54333&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf54333",
  null
  
)

component.options.__file = "Progress.vue"
export default component.exports